export function applyPrototypeToInstance(constructorFunction: any) {
    if (!(Object.getPrototypeOf(this) instanceof constructorFunction)) {
        Object.getOwnPropertyNames(constructorFunction.prototype).forEach(name => {
            if (name != "constructor" && name != "__proto__")
                this[name] = constructorFunction.prototype[name].bind(this);
        });
    }
};

function extendStatics(baseClass: any, superClass: any) {
    var internalExtendStatics = Object.setPrototypeOf || {
        __proto__: []
    } instanceof Array && function (baseClass, superClass) {
        baseClass.__proto__ = superClass;
    } || function (baseClass, superClass) {
        for (var property in superClass) if (Object.prototype.hasOwnProperty.call(superClass, property)) baseClass[property] = superClass[property];
    };
    return internalExtendStatics(baseClass, superClass);
};

/**
 * Funktion, um die Vererbung einer JS-Klasse von einer TS-Oberklasse zu definieren
 * Entspricht genau der __extends Funktion, die vom TypeScriptCompiler mit Target ES5 generiert wird, wenn eine Klasse mit extends keyword von einer anderen Klasse erbt 
 * @param baseClass Die erbende Klasse
 * @param superClass Die Klasse, von der geerbt wird
 */
export function extend(baseClass: any, superClass: any) {
    extendStatics(baseClass, superClass);
    function __() {
        this.constructor = baseClass;
    }
    baseClass.prototype = superClass === null ? Object.create(superClass) : (__.prototype = superClass.prototype, new __());
};